<script lang="ts">
  import ArrowLink from "$lib/atoms/ArrowLink.svelte";
  export let job: any;

  let jobPieces = [
    job?.id,
    job?.title,
    job?.departments?.[0].name,
    job?.location?.name,
  ];
  let titleElementId = `job-${job.id}`;
</script>

<a
  href={`/careers/open-roles/${job?.id}`}
  class="career-preview-card flex flex-col sm:flex-row sm:items-center bg-white p-6 lg:p-[30px] rounded-[6px] no-underline text-inherit group"
>
  <div class="flex-auto mr-6">
    <h3 class="type:h4 mb-4" id={titleElementId}>{@html job.title}</h3>
    <div
      class="flex flex-wrap -ml-6 text-black leading-snug text-[14px] lg:text-[16px]"
    >
      <div class="pl-6 font-bold">
        {@html job.departments.length > 0 ? job.departments[0]?.name : ""}
      </div>
      <div class="pl-6">{@html job.location?.name || ""}</div>
    </div>
  </div>
  <div
    class="md:opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-100 mt-4 sm:mt-0 self-end sm:self-center"
  >
    <ArrowLink class="reduced hover-red-bg" labelElement={titleElementId} />
  </div>
</a>

<style lang="scss">
  :global(.career-preview-card .button-label) {
    display: none !important;
  }
</style>
